const BASE_URL = "https://lotusapi.hitnish.com/api/";

export const API_URL = {
  CATEGORY_LIST: `${BASE_URL}category`,
  CATEGORY_GET: `${BASE_URL}category/show`,
  CATEGORY_SAVE: `${BASE_URL}category/store`,
  CATEGORY_UPDATE: `${BASE_URL}category/update`,
  CATEGORY_DELETE: `${BASE_URL}category/delete`,

  SUB_CATEGORY_LIST: `${BASE_URL}sub-category`,
  SUB_CATEGORY_GET: `${BASE_URL}sub-category/show`,
  SUB_CATEGORY_SAVE: `${BASE_URL}sub-category/store`,
  SUB_CATEGORY_UPDATE: `${BASE_URL}sub-category/update`,
  SUB_CATEGORY_DELETE: `${BASE_URL}sub-category/delete`,
  ADMIN_SUB_CATEGORY_BY_CATEGORY: `${BASE_URL}category/sub-category`,

  COMPANY_LIST: `${BASE_URL}company`,
  COMPANY_GET: `${BASE_URL}company/show`,
  COMPANY_SAVE: `${BASE_URL}company/store`,
  COMPANY_UPDATE: `${BASE_URL}company/update`,
  COMPANY_DELETE: `${BASE_URL}company/delete`,

  GRADE_LIST: `${BASE_URL}grade`,
  GRADE_GET: `${BASE_URL}grade/show`,
  GRADE_SAVE: `${BASE_URL}grade/store`,
  GRADE_UPDATE: `${BASE_URL}grade/update`,
  GRADE_DELETE: `${BASE_URL}grade/delete`,

  CITY_LIST: `${BASE_URL}city`,
  CITY_GET: `${BASE_URL}city/show`,
  CITY_SAVE: `${BASE_URL}city/store`,
  CITY_UPDATE: `${BASE_URL}city/update`,
  CITY_DELETE: `${BASE_URL}city/delete`,

  COUNTRY_LIST: `${BASE_URL}country`,
  COUNTRY_GET: `${BASE_URL}country/show`,
  COUNTRY_SAVE: `${BASE_URL}country/store`,
  COUNTRY_UPDATE: `${BASE_URL}country/update`,
  COUNTRY_DELETE: `${BASE_URL}country/delete`,

  STATE_LIST: `${BASE_URL}state`,
  STATE_GET: `${BASE_URL}state/show`,
  STATE_SAVE: `${BASE_URL}state/store`,
  STATE_UPDATE: `${BASE_URL}state/update`,
  STATE_DELETE: `${BASE_URL}state/delete`,

  TRANSPORT_LIST: `${BASE_URL}transport`,
  TRANSPORT_GET: `${BASE_URL}transport/show`,
  TRANSPORT_SAVE: `${BASE_URL}transport/store`,
  TRANSPORT_UPDATE: `${BASE_URL}transport/update`,
  TRANSPORT_DELETE: `${BASE_URL}transport/delete`,

  PARTY_LIST: `${BASE_URL}party`,
  PARTY_GET: `${BASE_URL}party/show`,
  PARTY_SAVE: `${BASE_URL}party/store`,
  PARTY_UPDATE: `${BASE_URL}party/update`,
  PARTY_DELETE: `${BASE_URL}party/delete`,
  PARTY_UPDATE_STATUS: `${BASE_URL}party/update-status`,

  SIZE_LIST: `${BASE_URL}size`,
  SIZE_GET: `${BASE_URL}size/show`,
  SIZE_SAVE: `${BASE_URL}size/store`,
  SIZE_UPDATE: `${BASE_URL}size/update`,
  SIZE_DELETE: `${BASE_URL}size/delete`,

  POST_LIST: `${BASE_URL}posts`,
  POST_GET: `${BASE_URL}posts/show`,
  POST_SAVE: `${BASE_URL}posts/store`,
  POST_UPDATE: `${BASE_URL}posts/update`,
  POST_DELETE: `${BASE_URL}posts/delete`,

  CATALOGUE_LIST: `${BASE_URL}catalogue`,
  CATALOGUE_GET: `${BASE_URL}catalogue/show`,
  CATALOGUE_SAVE: `${BASE_URL}catalogue/store`,
  CATALOGUE_UPDATE: `${BASE_URL}catalogue/update`,
  CATALOGUE_DELETE: `${BASE_URL}catalogue/delete`,

  SERIES_LIST: `${BASE_URL}series`,
  SERIES_GET: `${BASE_URL}series/show`,
  SERIES_SAVE: `${BASE_URL}series/store`,
  SERIES_UPDATE: `${BASE_URL}series/update`,
  SERIES_DELETE: `${BASE_URL}series/delete`,
  SERIES_IMAGES: `${BASE_URL}series/images`,
  SERIES_SAVE_IMAGE: `${BASE_URL}series/save-image`,
  SERIES_DELETE_IMAGE: `${BASE_URL}series/delete-image`,
  SERIES_PAGE_NUMBER: `${BASE_URL}series/order-image`,

  PRODUCT_LIST: `${BASE_URL}product`,
  PRODUCT_GET: `${BASE_URL}product/show`,
  PRODUCT_SAVE: `${BASE_URL}product/store`,
  PRODUCT_UPDATE: `${BASE_URL}product/update`,
  PRODUCT_DELETE: `${BASE_URL}product/delete`,
  PRODUCT_WITH_SUB_LIST: `${BASE_URL}product/lists`,
  PRODUCT_ONLY_LIST: `${BASE_URL}product/only`,
  PRODUCT_HAS_SUB_LIST: `${BASE_URL}product/has-sub-product`,

  SUB_PRODUCT_LIST: `${BASE_URL}sub-product`,
  SUB_PRODUCT_GET: `${BASE_URL}sub-product/show`,
  SUB_PRODUCT_SAVE: `${BASE_URL}sub-product/store`,
  SUB_PRODUCT_UPDATE: `${BASE_URL}sub-product/update`,
  SUB_PRODUCT_DELETE: `${BASE_URL}sub-product/delete`,

  BANKS_LIST: `${BASE_URL}banks`,
  BANKS_GET: `${BASE_URL}banks/show`,
  BANKS_SAVE: `${BASE_URL}banks/store`,
  BANKS_UPDATE: `${BASE_URL}banks/update`,
  BANKS_DELETE: `${BASE_URL}banks/delete`,

  SALES_RETURN_LIST: `${BASE_URL}sales-return`,
  SALES_RETURN_SAVE: `${BASE_URL}sales-return/store`,
  SALES_RETURN_SHOW: `${BASE_URL}sales-return/show`,
  SALES_RETURN_DELETE: `${BASE_URL}sales-return/delete`,

  SAVE_USER: `${BASE_URL}save-user`,
  SETTING_PASSWORD: `${BASE_URL}password-update`,
  LOGIN_URL: `${BASE_URL}login`,
  STATES_LIST: `${BASE_URL}states`,
  LOGIN_USER: `${BASE_URL}me`,

  INVOICE_LIST: `${BASE_URL}sales`,
  INVOICE_GET: `${BASE_URL}sales/show`,
  INVOICE_SAVE: `${BASE_URL}sales/store`,
  INVOICE_UPDATE: `${BASE_URL}sales/update`,
  INVOICE_DELETE: `${BASE_URL}sales/delete`,
  INVOICE_STATUS_UPDATE: `${BASE_URL}sales/status-update`,

  PAYMENT_LIST: `${BASE_URL}payments`,
  PAYMENT_GET: `${BASE_URL}payments/show`,
  PAYMENT_SAVE: `${BASE_URL}payments/store`,
  PAYMENT_UPDATE: `${BASE_URL}payments/update`,
  PAYMENT_DELETE: `${BASE_URL}payments/delete`,

  NOTIFICATION: `${BASE_URL}send-notification`,
  
  LEDGER_LIST: `${BASE_URL}ledgers`,
  OUTSTANDING: `${BASE_URL}ledgers/outstanding`,
};
